import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';

const AutomatedVoterReportPage = lazy(() =>
  import('src/pages/superadmin/automated-voter-report'),
);

export const automatedVoterReportRoutes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'superadmin/automated-voter-report',
        element: <AutomatedVoterReportPage />,
      },
    ],
  },
];
